/**
 * @generated SignedSource<<00b435be9543668963f078ddf45e014a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskListStatus$data = {
  readonly completed: number;
  readonly total: number;
  readonly " $fragmentType": "TaskListStatus";
};
export type TaskListStatus$key = {
  readonly " $data"?: TaskListStatus$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskListStatus">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskListStatus",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    }
  ],
  "type": "TrackedIssueCompletion",
  "abstractKey": null
};

(node as any).hash = "57fc5c1b0fd4cc1eaa91be6fb3a1e178";

export default node;
